<template>
  <div class="paper-con">
    <h3 v-if="$route.name === 'technicalQAHistoryGuoJiao' || $route.name === 'technicalQAHistory'"
        :style="{top: $route.name === 'technicalQAHistoryGuoJiao' ? '0' : '80px'}">参考文献</h3>
    <div class="paper-list" v-loading="loading">
      <div class="paper-item" v-for="(ref, idx) in paperListData" :key="idx">
        <p class="title">
          <span>{{ idx }}. </span>
          <a @click="toPaperDetails(ref.title, ref.url)">{{ ref.title }}</a>
          <img
            v-if="ref.pdf"
            @click="toPdf(ref.pdf)"
            :src="require('@/assets/images/common/PDF.png')"
            alt=""
          />
        </p>

        <p class="text" :title="ref.text">{{ ref.text }}</p>
        <p class="author">
          <span>作者：</span>
          <span v-for="(author, i) in ref.authors" :key="i"
            >{{ author.name }}；</span
          >
        </p>
        <p class="year">
          <span>{{ ref.year }}</span>
          <span>{{ ref.venue }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { matchtitleApi } from '@/api/chat';

export default {
  name: 'paperListComp',
  components: {},
  props: ['paperListData'],
  data() {
    return {
      loading: false,
    };
  },
  created() {},
  methods: {
    /**
     * 根据论文title和url查询论文详情
     * @param title
     * @param url
     */
    toPaperDetails(title, url) {
      this.loading = true;
      matchtitleApi({ title, url })
        .then((res) => {
          if (res.match) {
            let obj = {
              name: 'paperDetail',
              query: { id: res.data },
            };
            let routeData = this.$router.resolve(obj);
            window.open(routeData.href, '_blank');
          } else {
            window.open(url, '_blank');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 跳转原文pdf
    toPdf(url) {
      window.open(url, '_blank');
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
.paper-con {
  position: relative;
  padding-top: 45px;
  padding-right: 20px;

  .paper-list {
    max-height: calc(100vh - 45px);
  }

  > h3 {
    font-size: 15px;
    color: #333333;
    padding: 15px 10px;
    position: fixed;
    background-color: #ffffff;
    z-index: 99;
    width: 100%;
  }
  .paper-item {
    padding: 10px 0 10px 20px;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.1);

    > p {
      font-size: 13px;

      &:not(:last-of-type) {
        margin-bottom: 10px;
      }
    }

    .title {
      font-size: 14px;
      line-height: 22px;
      color: #1241C9;
      a {
        color: #1241C9;

        &:hover {
          text-decoration: underline;
        }
      }

      img {
        width: 20px;
        cursor: pointer;
        vertical-align: middle;
        display: inline-block;
        margin-top: -3px;
        margin-left: 10px;
      }
    }

    .text {
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 18px;
      color: #666;
      cursor: default;
      text-align: justify;
    }

    .author {
      color: #333;
      line-height: 18px;
    }

    .year {
      color: #666666;
      line-height: 18px;
      span {
        padding-right: 15px;
      }
    }
  }
}
</style>
